module.exports = __webpack_public_path__ + "img/group.7cab5788.png";